import { createSelector } from '@reduxjs/toolkit';
import { selectBuildingHeatingType } from 'shared/selectors/jsonQuery';
import { EBuildingHeatingType } from '../../../../packages/api-models/common/json_query';

const OPTIONS = [
  { label: 'Автономное', value: EBuildingHeatingType.Autonomous },
  { label: 'Центральное', value: EBuildingHeatingType.Central },
  { label: 'Нет', value: EBuildingHeatingType.Without },
];

export const selectBuildingHeatingTypeFilter = createSelector(selectBuildingHeatingType, value => ({
  label: 'Отопление',
  options: OPTIONS,
  value: value && value.length > 0 ? value : [null],
}));
